import type { Component } from "vue";

export const routes = [
  {
    path: "/listing/manage",
    name: "listing-manager",
    component: (): Promise<Component> => import("./views/ChannelListingManager.vue"),
    meta: { requiresAuth: true, requiredRoles: [], requiredGroups: [] },
  },
];
